import { Controller, useFormContext } from 'react-hook-form'

import Select from 'shared/ui/form/Select'

import { TFormRules } from './types'

import styles from './ControlledSelectField.module.scss'

interface ControlledSelectFieldProps {
  name: string
  label: string
  required?: boolean
  rules: TFormRules
  options: { value: string | number; label: string }[]
  disabled?: boolean | null
  size?: 'medium' | 'large'
  id: string
}

export function ControlledSelectField({
  label,
  id,
  name,
  options,
  required = false,
  rules,
  size = 'large'
}: ControlledSelectFieldProps) {
  const {
    control,
    formState: { errors }
  } = useFormContext()

  const error = errors?.[name]
  const errorMessage =
    typeof error?.message === 'string' ? error.message : undefined

  const optionsArray = options.map(option => ({
    label: option.label,
    value: option.value.toString()
  }))

  return (
    <div
      {...{ size }}
      className={styles.selectWrapper}
    >
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field: { onChange, ...rest } }) => {
          return (
            <Select
              id={id}
              {...rest}
              onChange={(_name, value) => onChange(value)}
              label={label}
              size={size}
              noMargin
              required={required}
              errorMessage={errorMessage}
              options={optionsArray}
            ></Select>
          )
        }}
      />
    </div>
  )
}
